<template>
    <v-layout id="identity" row wrap xs12>
        <v-flex xs4>
            <v-autocomplete class="pt-0" ref="civilite" id="civilite" name="civilite"
                            :items="$storeCandidature.configurationClient.CiviliteList"
                            v-model="$storeCandidature.sasCandidature.Identification.Civilite"
                            :label="$storeCandidature.langueFormulaire == 'en' ? 'Gender' : 'Civilité'"
                            :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                            item-value="Id"
                            return-object
                            chips
                            deletable-chips
                            :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                            @change="onUpdate">
            </v-autocomplete>
        </v-flex>
        <v-flex xs4>
            <v-text-field ref="nom" id="" name="nom"
                          :counter="20"
                          v-model="$storeCandidature.sasCandidature.Identification.NomContact"
                          :label="$storeCandidature.langueFormulaire == 'en' ? 'Last name' : 'Nom'"
                          :disabled="$storeCandidature.sasCandidature.IdCrypte != null"
                          :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                          @change="onUpdate">
            </v-text-field>
        </v-flex>
        <v-flex xs4>
            <v-text-field :counter="20"
                          v-model="$storeCandidature.sasCandidature.Identification.PrenomContact"
                          :label="$storeCandidature.langueFormulaire == 'en' ? 'First name' : 'Prénom'"
                          :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                          :disabled="$storeCandidature.sasCandidature.IdCrypte != null"
                          @change="onUpdate">
            </v-text-field>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        methods: {
            onUpdate() {
                this.$storeCandidature.candidatureChanged = true;
                this.$emit('Valide')
            }
        }
    }
</script>

<style scoped>
</style>